import { useEffect } from "react";
import { useState } from "react";

export const useGetData = () => {
    const [newsData, setNewsData] = useState();
    //console.log(newsData)
    useEffect(() => {
      const api = async () => {
        await fetch("assets/data/data.json", {
          method: "GET"
        })
          .then(res => res.json())
          .then(res => {
            return res;
          })
          .then(data => {
            setNewsData(data);
          });
      };
      api();
    }, []);
    return newsData;
  };